import { useMemo } from "react";
import { useIsCountdownRedirectEnabled } from "@circle-react/components/Paywalls/Checkout/hooks/useIsCountdownRedirectEnabled";
import { skipCountdownRedirectsName } from "@circle-react/helpers/paywallCustomizationHelpers";

export const useCheckoutUrl = (props: Record<string, string> = {}): string => {
  const isCountdownRedirectEnabled = useIsCountdownRedirectEnabled();

  return useMemo(() => {
    const url = new URL(window.location.href);
    const keys = Object.keys(props);

    if (isCountdownRedirectEnabled) {
      url.searchParams.set(skipCountdownRedirectsName, "true");
    }

    keys.forEach((key: string) => {
      url.searchParams.set(key, props[key]);
    });

    return url.href;
  }, [isCountdownRedirectEnabled, props]);
};
